export default {
  // TaxonomyView
  defaultTaxonomyMessage: 'Ésta es la {taxonomy} predeterminada para la Institución.',
  level: 'Nivel',
  verb: 'Verbo',
  verbs: 'Verbos',
  noCognitiveLevelsCreated: 'No tiene Niveles Cognitivos creados.',
  createCognitiveLevel: 'Crear Nivel Cognitivo',
  verbsWithoutCognitiveLevel: 'Verbos utilizados sin Nivel Cognitivo',
  noVerbsToShow: 'No hay verbos para mostrar.',

  // TaxonomyForm
  default: 'Predeterminado',
  defaultTaxonomyDescription: 'Define si la {taxonomy} será la predefinida para la Institución.',
  defaultTaxonomyTooltip: 'Si se activa, el resto de las {taxonomies} se modificaran para que ésta sea la única activa.',

  // CognitiveLevelForm
  defaultColor: 'Color por defecto:',
  applyDefaultColor: 'Aplicar el color por defecto',
  colorLabel: 'Color:',

  // CognitiveLevelRow
  levelLabel: 'Nivel {level}',
  insertNamePlaceholder: 'Inserte el nombre aquí...',
  insertDescriptionPlaceholder: 'Inserte la descripción aquí...',
  changeColor: 'Cambiar Color',
  dragToOrder: 'Arrastrar para ordenar el {cognitiveLevel}.',
  editCognitiveLevel: 'Editar Nivel Cognitivo',
  changeColorTo: 'Cambiar color al {cognitiveLevel}',
  cognitiveLevelCreated: '{cognitiveLevel} creado.',
  cognitiveLevelUpdated: '{cognitiveLevel} actualizado.',
}
